import { LoginForm } from '../components/LoginForm';

export function LoginPage() {
  return (
    <div data-testid="login-page" className="flex min-h-screen">
      {/* Left panel — brand with background image */}
      <div
        data-testid="login-photo-panel"
        className="hidden w-1/2 flex-col p-[52px] xl:flex"
        style={{
          background: `linear-gradient(160deg, rgba(30,58,95,0.85) 0%, rgba(47,90,122,0.75) 100%), url('/login-bg.png') center/cover no-repeat`,
        }}
      >
        {/* Logo */}
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center overflow-hidden" style={{ marginLeft: '-4px' }}>
            <img src="/XXtract-Logo.png" alt="XXtract" className="h-full w-full object-contain" />
          </div>
          <span className="text-[22px] font-bold text-white">XXtract</span>
        </div>

        {/* Content — vertically centered */}
        <div className="flex flex-1 flex-col justify-center">
          <h1
            data-testid="login-tagline"
            className="mb-4 leading-[1.3]"
            style={{
              fontSize: '26px',
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: 'white',
            }}
          >
            Sneller in het schap.<br />Zonder risico.
          </h1>
          <p
            className="mb-8 max-w-sm leading-relaxed"
            style={{ fontSize: '14px', color: 'rgba(255,255,255,0.85)' }}
          >
            Uw productdata op orde, compleet en klaar voor de markt — zodat u zich kunt richten op groei.
          </p>
        </div>
      </div>

      {/* Right panel — form */}
      <div
        data-testid="login-form-panel"
        className="flex flex-1 flex-col items-center justify-center p-12"
        style={{ backgroundColor: 'var(--background)' }}
      >
        <div className="w-full max-w-[360px]">
          <LoginForm />
        </div>
      </div>
    </div>
  );
}
